import React, { useEffect, useState } from 'react'
import { ImageSlider } from '../../../components/imageSlider';

export const ImageContainer = ({ className="", style={}, ...rest }) => {
  const [speed, setSpeed] = useState(window.innerWidth < 1024 ? 150 : 75);
  const [parts, setParts] = useState(window.innerWidth < 1024 ? 4 : 8);
  
  useEffect(()=>{
    const listener = ()=>{
      setSpeed(window.innerWidth < 1024 ? 150 : 75);
      setParts(window.innerWidth < 1024 ? 4 : 6)
    }

    window.addEventListener('resize', listener);
    return ()=>{
      window.removeEventListener('resize', listener);
    }
  },[]);
  
  return (
    <ImageSlider
      className={`relative h-full w-full ${className}`}
      style={style}
      interval={7_500}
      speed={speed}
      parts={parts}

      images={[
        '/images/data-analytics.png',
        `/images/unlock_potential.png`,
        '/images/web-development.png'
      ]}

      { ...rest }
    />
  )
}
